(ns iris.posts.ref-preview
  (:require
   [re-frame.core :as re-frame]
   [cljs.core.async :refer [go]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.events :as events]
   [iris.globals :as globals]
   [iris.indexeddb :as idb]
   [iris.posts.helpers :as helpers]))

(def http-loading-event :iris.posts.events/http-loading)
(def set-ref-preview-event :iris.posts.events/set-post-ref-preview)
(def set-ref-preview-data-event :iris.posts.events/set-post-ref-preview-data)
(def unset-ref-preview-data-event :iris.posts.events/unset-post-ref-preview-data)
(def load-ref-preview-data-event :iris.posts.events/load-post-ref-preview-data)

;; TODO: set-post-ref-preview is no longer in use, consider deleting (replaced by set-post-ref-preview-data)
(re-frame/reg-event-db
 set-ref-preview-event
 (fn [db [_ data]]
   (assoc-in db [:posts :ref-preview] data)))

(re-frame/reg-event-db
 set-ref-preview-data-event
 (fn [db [_ paruid ruid data]]
   (let [ruid (helpers/normalize-post-ref-ruid ruid)
         legacy-ruid (str "@" ruid)
         ref-preview-path [:posts :ref-preview-data (keyword paruid)]]
     (-> db
         (update-in ref-preview-path dissoc (keyword legacy-ruid))
         (assoc-in (conj ref-preview-path (keyword ruid)) data)))))

(re-frame/reg-event-db
 unset-ref-preview-data-event
 (fn [db [_ paruid ruid]]
   (update-in db [:posts :ref-preview-data (keyword paruid)] dissoc (keyword ruid))))

;; https://clojureverse.org/t/how-to-replace-cljs-http-client-get-with-js-fetch/9490
(defn fetch-post [ruid]
  (let [jwt @globals/jwt]
    (js/fetch js/apolloURL
              (clj->js {:method "POST"
                        :headers {:authorization (str "Bearer " jwt)
                                  :content-type "application/json"}
                        :body (js/JSON.stringify (clj->js {:jsonrpc "2.0"
                                                           :id 0
                                                           :method "Post2a.Get"
                                                           :params {:options {:debug false}
                                                                    :data {:ruid ruid
                                                                           :include_screening_status false}}}))}))))

(defn set-post-ref-preview-data [paruid ruid preview]
  (re-frame/dispatch [set-ref-preview-data-event paruid ruid (merge preview {:dt (.now js/Date)})]))

(defn fetch-cache-set-post-ref-preview-data [paruid ruid]
  (when-let [ruid (helpers/normalize-post-ref-ruid ruid)]
    (let [request-id (events/track-manual-request-start "Post2a.Get" "preview")]
      (re-frame/dispatch [http-loading-event true])
      (go
        (try
          (let [res (<p! (fetch-post ruid))]
            (if (= 200 (.. res -status))
              (let [body (-> (<p! (.. res (json)))
                             (js->clj :keywordize-keys true))]
                (idb/add-ref-preview ruid (clj->js (get-in body [:result :data])))
                (re-frame/dispatch [set-ref-preview-data-event paruid ruid (merge (get-in body [:result :data]) {:dt (.now js/Date)})])
                (events/track-manual-request-success request-id body))
              (events/track-manual-request-failure request-id (str "HTTP " (.. res -status)))))
          (catch :default e
            (events/track-manual-request-failure request-id (or (.-message e) "Request failed.")))
          (finally
            (re-frame/dispatch [http-loading-event false])))))))

(defn- get-ruid-from-a-target-href [target]
  (helpers/post-ref-href->ruid (.getAttribute target "href")))

(defn- get-ruid-from-a-target-parent-article [target]
  (when-let [article (.closest target "article")]
    (-> article
        (.getAttribute "ruid")
        (->> (str "@")))))

(re-frame/reg-event-fx
 load-ref-preview-data-event
 (fn [{:keys [db]} [_ paruid ruid]]
   (when-let [ruid (helpers/normalize-post-ref-ruid ruid)]
     (let [preview (get-in db [:posts :ref-preview-data (keyword paruid) (keyword ruid)])
           batch-datetime (or (get-in db [:posts :batch-datetime]) 0)]
       (when (or (nil? preview)
                 (< (:dt preview 0) batch-datetime))
         (go
           (if preview
             (set-post-ref-preview-data paruid ruid preview)
             (if-let [cached-preview (-> (<p! (idb/get-ref-preview ruid))
                                         (js->clj :keywordize-keys true))]
               (set-post-ref-preview-data paruid ruid cached-preview)
               (fetch-cache-set-post-ref-preview-data paruid ruid)))))))
   {}))

(defn load-post-ref-from-a-pref-mouseover-event [target]
  (when-let [ruid (get-ruid-from-a-target-href target)]
    (when-let [paruid (get-ruid-from-a-target-parent-article target)]
      (re-frame/dispatch [load-ref-preview-data-event paruid ruid]))))
